<template>
  <div class="conditions-left-bar">
    <div class="zone"
         v-for="(zone, index) in zones"
         :key="index"
         :class="{ 'active': index === activeZoneIndex }"
         @mouseenter="processMouseEnterZone(index)"
         @mouseleave="processMouseLeaveZone()"
    >
      <div class="marker" :style="{ backgroundColor: zone.color }"></div>
      <div class="text">
        <div class="title">Зона доставки {{ index + 1 }}</div>
        <div class="subtitle">Минимальный заказ {{ zone.minSum }} <rub /></div>
      </div>
    </div>
    <div class="message">
      Время доставки заказа: от 1 часа<br/><br/>
      *Время доставки может изменяться в связи с дорожной ситуацией
    </div>
  </div>
</template>

<script>
  import { deliveryZones } from '/src/store/config.js'

  export default {
    name: 'ConditionsLeftBar',
    data () {
      return {
        zones: deliveryZones,
        activeZoneIndex: null
      }
    },
    mounted () {
      this.$bus.$on('set-delivery-zone-clients_front', (index) => {
        this.activeZoneIndex = index
      })
    },
    beforeDestroy () {
      this.$bus.$off('set-delivery-zone-clients_front')
    },
    methods: {
      processMouseEnterZone (index) {
        this.$bus.$emit('hover-delivery-zone-left-bar', index)
      },
      processMouseLeaveZone () {
        this.$bus.$emit('hover-delivery-zone-left-bar', null)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/blocks/ConditionsLeftBar.vue